// =============================================================
// Contract addresses per network for the combined DEX
// (sell SCN -> USDT  and  sell CORE -> USDT).
// >>> FILL THESE IN. <<<  Reads the set matching ACTIVE_NETWORK.
// =============================================================

export const CONTRACTS = {
  opbnbMainnet: {
    scnToken:  "0xBaF4ecB5e576e989B89cd0D5C84f91F341334aBE",
    scnDex:    "0x8d809557A5E19040EF0a8F3890964f8EAD08D0E3",
    coreToken: "0xd74eEFB91c31E382590AaB62c4F6142b3f234874",
    coreDex:   "0x78415EfBDDD221ebd209fDb1295c55E5a3205F02",
    usdt:      "0x9e5aac1ba1a2e6aed6b32689dfcf62a509ca96f3",
  },

  opbnbTest: {
    scnToken:  "0x8E1a4f77F94fa1707fEBb3441a6cc600Eb45BcB5",
    scnDex:    "0xEBc961CD38Bf6156f7B86d8A12725FA6c935FFbF",
    coreToken: "0xe62189E6f6d8D95Fd16C3fe5cbf0FA1D4CAB6B49",
    coreDex:   "0x9739a6911c62423c55deAdeef6694B51b09AAb09",
    usdt:      "0xBf6596a279172D330b8b732D257Ee633B6FDA911",
  },
};
